export class CmbEntity {
  public Id: number;
  public Detalle: string;
  public IdPreSet: any;
  public IdUsuario: any;
}
